module.exports = __webpack_public_path__ + "static/media/wre1.png.454781dd.jpg";